import { useGetAgentProfile, useInvalidateUseGetAgentProfile } from '@urbanx/agx.agencies.client';
import {
  AgxButton,
  AgxLoadingState,
  AgxSpacer,
  AgxTypography,
  useFirstPaintLoader,
} from '@urbanx/agx.ui-components2';

import ProfileSettingsForm from './components/ProfileSettingsForm';

const ProfileSettingsPage = () => {
  const { data: agentProfile, isPending, isError } = useGetAgentProfile();
  const invalidateAgentProfile = useInvalidateUseGetAgentProfile();

  useFirstPaintLoader({ isInitialLoadComplete: !isPending });

  if (isPending) return <AgxLoadingState />;

  if (isError || !agentProfile) {
    return (
      <AgxSpacer gap="spacing-xl" contentAlignment="center" contentJustification="center" fill>
        <AgxTypography
          id="profile-settings-error"
          type="body_ui"
          size="medium"
          color="var(--text-tertiary)"
        >
          Unable to load your profile.
        </AgxTypography>
        <AgxButton
          id="retry-agent-profile"
          text="Try again"
          variant="primary"
          onClick={() => void invalidateAgentProfile()}
        />
      </AgxSpacer>
    );
  }

  return <ProfileSettingsForm agentProfile={agentProfile} />;
};

export default ProfileSettingsPage;
